import { render, staticRenderFns } from "./MealItemMarkStatusDialog.vue?vue&type=template&id=580387a8&scoped=true"
import script from "./MealItemMarkStatusDialog.vue?vue&type=script&lang=js"
export * from "./MealItemMarkStatusDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "580387a8",
  null
  
)

export default component.exports